import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row, Input} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {downloadFile, getDatePickerProps, selectStyles} from '../helpers/Utils';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import Api from '../services/Api';
import {store} from '../AppRenderer';
import i18n from '../services/i18n';
import Select from 'react-select';
import moment from 'moment';
import fa_IR from "../constants/locales";

class WithdrawsOutputForm extends React.Component {
  constructor(props) {
    super(props);
    this.tokenOptions = [
      {label: props.t('All'), value: ''},
      ...store.getState().general.tokens.map(token => ({
        label: props.t(token.symbol), value: token.symbol,
      }))
    ];
    this.statusOptions = [
      {label: props.t('All'), value: ''},
      {label: props.t('Accepted'), value: 'ACCEPTED'},
      {label: props.t('Pending'), value: 'PENDING'},
      {label: props.t('Confirmed'), value: 'CONFIRMED'},
      {label: props.t('Rejected'), value: 'REJECTED'},
    ];
  }

  downloadOutput = async values => {
    const {token, status, from, to} = values;
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-withdraws-download',
        null,
        {
          cancelToken: null,
          params: {
            ...(token.value ? {token: token.value} : null),
            ...(status.value ? {status: status.value} : null),
            ...(from ? {from: from.toISOString()} : null),
            ...(to ? {to: to.toISOString()} : null),
          },
        },
      );
      downloadFile(data.url);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t} = this.props;
    return(
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }
        })}
      >
        <FinalForm
          onSubmit={this.downloadOutput}
          initialValues={{
            token: this.tokenOptions[0],
            status: this.statusOptions[0],
            from: moment().subtract(7, 'days'),
            to: moment(),
          }}
          render={({handleSubmit, submitting}) => {
            return (
              <Form>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('Selected Token')}</span>
                    <Field name="token">
                      {({input}) => (
                        <Select
                          {...input}
                          className="w-100"
                          styles={selectStyles}
                          options={this.tokenOptions}
                          onChange={token => {input.onChange(token);}}
                          placeholder={t('Select')}
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('Selected Status')}</span>
                    <Field name="status">
                      {({input}) => (
                        <Select
                          {...input}
                          className="w-100"
                          styles={selectStyles}
                          options={this.statusOptions}
                          onChange={status => {input.onChange(status);}}
                          placeholder={t('Select')}
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('Start Date')}</span>
                    <Field name="from">
                      {({input}) => (
                        <MuiPickersUtilsProvider
                          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                          locale={i18n.language}
                        >
                          <DateTimePicker
                            {...getDatePickerProps()}
                            value={input.value ? input.value : null}
                            onChange={date => {input.onChange(date);}}
                            TextFieldComponent={props =>
                              <Input
                                style={{width: '100%'}}
                                placeholder={t('Select Date')}
                                {...props}
                              />
                            }
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('End Date')}</span>
                    <Field name="to">
                      {({input}) => (
                        <MuiPickersUtilsProvider
                          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                          locale={i18n.language}
                        >
                          <DateTimePicker
                            {...getDatePickerProps()}
                            value={input.value ? input.value : null}
                            onChange={date => {input.onChange(date);}}
                            TextFieldComponent={props =>
                              <Input
                                style={{width: '100%'}}
                                placeholder={t('Select Date')}
                                {...props}
                              />
                            }
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <LoaderButton
                      color="success"
                      onClick={handleSubmit}
                      loading={submitting}
                      className="text-center">
                      {t('Download Output File')}
                    </LoaderButton>
                    <Button
                      color="grey"
                      onClick={() =>{
                        ModalManager.close({
                          isOpen: false
                        });
                      }}
                      className="text-center mx-2"
                      style={{minWidth: 100}}>
                      {t('Close')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        />
      </ThemeProvider>
    );
  }
}

export default withTranslation()(WithdrawsOutputForm);
